import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dropFirstTimeFlag } from './actions';
import { hasFirstTimeFlag } from './selectors';
export function useFirstTimeFlag(flag) {
    var hasFlag = useSelector(function (state) { return hasFirstTimeFlag(state, flag); });
    var dispatch = useDispatch();
    var dropFlag = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, redirectTo = _b.redirectTo, withStateUpdate = _b.withStateUpdate;
        return dispatch(dropFirstTimeFlag({
            flag: flag,
            redirectTo: redirectTo,
            withStateUpdate: withStateUpdate,
        }));
    }, [flag, dispatch]);
    return { hasFlag: hasFlag, dropFlag: dropFlag };
}
//# sourceMappingURL=hooks.js.map